import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'cancel-subscription-modal',
	template: require('./cancel-subscription-modal.html'),
	styles: [require('./cancel-subscription-modal.scss')]
})
export class CancelSubscriptionModalComponent {
	constructor(private activeModal: NgbActiveModal) {}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	successClose(): void {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription/cancel-subscription-modal.ts